import globals from '../../plugins/globals';

export const floatingMenu = {
  init: function () {
    if (!globals.testsMode)
      this.makeFloatingMenu();
  },

  makeFloatingMenu: function () {
    if (window.pageYOffset > 30) {
      document.body.classList.add('menuFloating');      
    }
    else {
      document.body.classList.remove('menuFloating');
    }
  }

}
